(function () {
  if (window.kgAttr) return;

  var NAME = '_kg_attr';
  var MAX_AGE_S = 90 * 86400;
  var MAX_AGE_MS = MAX_AGE_S * 1000;
  var CLICK_KEYS = ['gclid', 'gbraid', 'wbraid', 'fbclid'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var PAID_MEDIUM = /^(cpc|ppc|paid|paid[_ -]?search|paid[_ -]?social|google[_ -]?search|cpm|cpv|display|shopping|pmax|ads?)$/i;
  var INTERNAL_REF = /(^|\.)(kogel\.cc|kogelbearings\.myshopify\.com|shop\.app|shopify\.com|paypal\.com|klarna\.com|afterpay\.com|global-e\.com)$/i;
  var HDYHAU = ['google', 'instagram_facebook', 'youtube', 'friend_club', 'shop_mechanic', 'escape_collective', 'other'];
  var CART_SETTLE_MS = 4000;
  var now = Date.now();
  var params = new URLSearchParams(window.location.search);
  var consent = { known: false, marketing: true, sale: true };
  var store = load();
  var touch = landingTouch();
  var hdyhau = (params.get('hdyhau') || '').toLowerCase();

  function clip(v, n) {
    return String(v).slice(0, n || 255);
  }

  function ss(op, k, v) {
    try {
      if (op === 'get') return sessionStorage.getItem(k);
      if (op === 'set') sessionStorage.setItem(k, v);
      if (op === 'del') sessionStorage.removeItem(k);
    } catch (e) {}
    return null;
  }

  function ls(op, k, v) {
    try {
      if (op === 'get') return localStorage.getItem(k);
      if (op === 'set') localStorage.setItem(k, v);
      if (op === 'del') localStorage.removeItem(k);
    } catch (e) {}
    return null;
  }

  function parse(s) {
    try {
      var v = JSON.parse(s);
      return v && typeof v === 'object' ? v : null;
    } catch (e) {
      return null;
    }
  }

  function fresh(t) {
    return t && typeof t.at === 'number' && now - t.at < MAX_AGE_MS && t.at <= now + 60000 ? t : null;
  }

  function load() {
    var m = document.cookie.match(/(?:^|;\s*)_kg_attr=([^;]*)/);
    var a = m ? parse(decodeURIComponent(m[1])) : null;
    var b = parse(ls('get', NAME));
    var f = [a && fresh(a.f), b && fresh(b.f)].filter(Boolean).sort(function (x, y) { return x.at - y.at; })[0] || null;
    var l = [a && fresh(a.l), b && fresh(b.l)].filter(Boolean).sort(function (x, y) { return y.at - x.at; })[0] || null;
    return { v: 1, f: f, l: l };
  }

  function refHost() {
    if (!document.referrer) return '';
    try {
      var h = new URL(document.referrer).hostname.toLowerCase();
      return INTERNAL_REF.test(h) || h === window.location.hostname ? '' : clip(h, 80);
    } catch (e) {
      return '';
    }
  }

  function landingTouch() {
    var t = {};
    CLICK_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) t[k] = clip(v.trim(), 300);
    });
    if (t.fbclid) {
      t.fbc = 'fb.1.' + now + '.' + t.fbclid;
      delete t.fbclid;
    }
    UTM_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) t[k] = clip(v.trim(), 150);
    });
    var ref = refHost();
    if (!Object.keys(t).length && !ref) return null;
    if (ref) t.ref = ref;
    t.at = now;
    t.lp = clip(window.location.pathname, 120);
    return t;
  }

  function isPaid(t) {
    return !!(t && (t.gclid || t.gbraid || t.wbraid || t.fbc || PAID_MEDIUM.test(t.utm_medium || '')));
  }

  function apply() {
    var changed = false;
    if (!store.f) {
      store.f = touch || { at: now, lp: clip(window.location.pathname, 120) };
      changed = true;
    }
    if (touch && isPaid(touch) && (!store.l || store.l.at !== touch.at)) {
      store.l = touch;
      changed = true;
    }
    return changed;
  }

  function persist() {
    var json = JSON.stringify(store);
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = NAME + '=' + encodeURIComponent(json) + '; Max-Age=' + MAX_AGE_S + '; Path=/; SameSite=Lax' + secure;
    ls('set', NAME, json);
  }

  function forget() {
    document.cookie = NAME + '=; Max-Age=0; Path=/; SameSite=Lax';
    ls('del', NAME);
    store = { v: 1, f: null, l: null };
  }

  function payload() {
    var p = { v: 1, f: store.f, l: store.l };
    if (!consent.sale) p.ns = 1;
    return JSON.stringify(p);
  }

  function readConsent() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || typeof cp.marketingAllowed !== 'function') return false;
    var analytics = typeof cp.analyticsProcessingAllowed === 'function' ? cp.analyticsProcessingAllowed() : true;
    consent.known = true;
    consent.marketing = !!(cp.marketingAllowed() && analytics);
    consent.sale = typeof cp.saleOfDataAllowed === 'function' ? !!cp.saleOfDataAllowed() : true;
    return true;
  }

  function withConsent(cb) {
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      readConsent();
      cb();
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], finish);
      } catch (e) {
        finish();
      }
      setTimeout(finish, 3000);
    } else {
      finish();
    }
  }

  function cartGet() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function cartWrite(val) {
    var attrs = {};
    attrs[NAME] = val;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  var syncing = false;
  function syncCart(tries) {
    if (!consent.marketing || !store.f || syncing) return;
    var val = payload();
    syncing = true;
    cartGet()
      .then(function (cart) {
        var sig = (cart.token || '') + '|' + val;
        if (!cart.item_count) {
          ss('set', 'kg_attr_cart', 'empty|' + val);
          return null;
        }
        if ((cart.attributes || {})[NAME] === val) {
          ss('set', 'kg_attr_cart', sig);
          return null;
        }
        return cartWrite(val)
          .then(function () {
            return new Promise(function (r) { setTimeout(r, 800); });
          })
          .then(cartGet)
          .then(function (after) {
            if ((after.attributes || {})[NAME] === val) {
              ss('set', 'kg_attr_cart', (after.token || '') + '|' + val);
              return null;
            }
            return 'retry';
          });
      })
      .catch(function () {
        return 'retry';
      })
      .then(function (res) {
        syncing = false;
        var left = tries === undefined ? 2 : tries;
        if (res === 'retry' && left > 0) setTimeout(function () { syncCart(left - 1); }, 1500);
      });
  }

  function maybeSyncCart(force) {
    if (!consent.marketing || !store.f) return;
    var last = ss('get', 'kg_attr_cart');
    var onCartPage = /^\/cart\/?$/.test(window.location.pathname);
    if (!force && !onCartPage && last && last.slice(last.indexOf('|') + 1) === payload()) return;
    syncCart();
  }

  function iso(ms) {
    try {
      return new Date(ms).toISOString();
    } catch (e) {
      return '';
    }
  }

  function clickId(t) {
    if (!t) return '';
    if (t.gclid) return 'gclid:' + t.gclid;
    if (t.gbraid) return 'gbraid:' + t.gbraid;
    if (t.wbraid) return 'wbraid:' + t.wbraid;
    if (t.fbc) return 'fbc:' + t.fbc;
    return '';
  }

  function profileProps() {
    var p = {};
    var f = store.f;
    var l = store.l;
    if (consent.marketing && f && (f.gclid || f.gbraid || f.wbraid || f.fbc || f.utm_source)) {
      if (f.gclid) p.kg_first_gclid = f.gclid;
      if (f.gbraid) p.kg_first_gbraid = f.gbraid;
      if (f.wbraid) p.kg_first_wbraid = f.wbraid;
      if (f.fbc) p.kg_first_fbc = f.fbc;
      if (f.utm_source) p.kg_first_utm_source = f.utm_source;
      if (f.utm_medium) p.kg_first_utm_medium = f.utm_medium;
      if (f.utm_campaign) p.kg_first_utm_campaign = f.utm_campaign;
      p.kg_first_touch_at = iso(f.at);
    }
    if (consent.marketing && l) {
      var id = clickId(l);
      if (id) p.kg_last_paid_click_id = id;
      if (l.utm_source) p.kg_last_paid_utm_source = l.utm_source;
      if (l.utm_campaign) p.kg_last_paid_utm_campaign = l.utm_campaign;
      p.kg_last_paid_touch_at = iso(l.at);
    }
    var h = parse(ls('get', 'kg_hdyhau'));
    if (h && HDYHAU.indexOf(h.a) > -1) {
      p.kg_hdyhau = h.a;
      p.kg_hdyhau_at = iso(h.at);
    }
    return p;
  }

  function klaviyoStub() {
    if (window.klaviyo) return;
    window._klOnsite = window._klOnsite || [];
    try {
      window.klaviyo = new Proxy({}, {
        get: function (target, name) {
          if (name === 'push') {
            return function () {
              window._klOnsite.push.apply(window._klOnsite, arguments);
            };
          }
          return function () {
            var args = Array.prototype.slice.call(arguments);
            var cb = typeof args[args.length - 1] === 'function' ? args.pop() : undefined;
            return new Promise(function (resolve) {
              window._klOnsite.push([name].concat(args, [function (r) {
                if (cb) cb(r);
                resolve(r);
              }]));
            });
          };
        }
      });
    } catch (e) {}
  }

  function klaviyoSync(extra) {
    var k = window.klaviyo;
    if (!k || typeof k.identify !== 'function') return;
    var p = profileProps();
    var withEmail = extra && extra.email;
    if (withEmail) p.email = extra.email;
    if (!Object.keys(p).length) return;
    var sig = JSON.stringify(p);
    if (!withEmail && ss('get', 'kg_attr_kl') === sig) return;
    var ready = withEmail ? Promise.resolve(true) : Promise.resolve(k.isIdentified());
    ready
      .then(function (yes) {
        if (!yes) return null;
        return Promise.resolve(k.identify(p)).then(function () {
          ss('set', 'kg_attr_kl', sig);
          if (p.kg_hdyhau) ls('del', 'kg_hdyhau');
          if (withEmail) ss('del', 'kg_attr_pending_email');
        });
      })
      .catch(function () {});
  }

  function watchForms() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || f.tagName !== 'FORM') return;
      var type = f.querySelector('input[name="form_type"]');
      var t = type ? type.value : '';
      if (t !== 'contact' && t !== 'customer') return;
      var em = f.querySelector('input[name="contact[email]"], input[type="email"]');
      var v = em && em.value ? em.value.trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return;
      ss('set', 'kg_attr_pending_email', JSON.stringify({ e: v, at: Date.now() }));
    }, true);
    window.addEventListener('klaviyoForms', function (e) {
      if (e && e.detail && e.detail.type === 'submit') setTimeout(function () { klaviyoSync(); }, 1500);
    });
  }

  function pendingEmail() {
    var p = parse(ss('get', 'kg_attr_pending_email'));
    if (!p || !p.e || Date.now() - p.at > 30 * 60000) return '';
    return /(?:^|[?&])(contact_posted|customer_posted)=true/.test(window.location.search) ? p.e : '';
  }

  function thanks() {
    var box = document.createElement('div');
    box.setAttribute('role', 'status');
    box.className = 'kg-hdyhau-thanks';
    box.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:2147483000;max-width:420px;margin:0 auto;padding:16px 48px 16px 18px;background:#111;color:#fff;border-radius:6px;box-shadow:0 6px 24px rgba(0,0,0,.25);font:inherit;line-height:1.45';
    var msg = document.createElement('p');
    msg.style.cssText = 'margin:0;color:inherit;font:inherit';
    msg.textContent = 'Thanks for telling us. It really helps. Ben and the Kogel team';
    var close = document.createElement('button');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.textContent = '×';
    close.style.cssText = 'position:absolute;top:8px;right:10px;width:32px;height:32px;border:0;background:none;color:#fff;font-size:22px;line-height:1;cursor:pointer';
    close.addEventListener('click', function () { box.remove(); });
    box.appendChild(msg);
    box.appendChild(close);
    document.body.appendChild(box);
    setTimeout(function () { if (box.parentNode) box.remove(); }, 12000);
  }

  if (HDYHAU.indexOf(hdyhau) > -1) {
    ls('set', 'kg_hdyhau', JSON.stringify({ a: hdyhau, at: now }));
    if (document.body) thanks();
  }

  klaviyoStub();
  watchForms();

  withConsent(function () {
    if (!consent.marketing) {
      forget();
    } else if (apply()) {
      persist();
    }

    var email = consent.marketing ? pendingEmail() : '';
    var kick = function () {
      klaviyoSync(email ? { email: email } : null);
      setTimeout(function () { klaviyoSync(); }, 4000);
    };
    var cartKick = function () {
      setTimeout(function () { maybeSyncCart(false); }, CART_SETTLE_MS);
    };
    if (document.readyState === 'complete') {
      kick();
      cartKick();
    } else {
      window.addEventListener('load', function () {
        kick();
        cartKick();
      });
    }
  });

  ['on:cart:add', 'on:cart:after-merge'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      setTimeout(function () { maybeSyncCart(true); }, CART_SETTLE_MS);
    });
  });

  document.addEventListener('visitorConsentCollected', function () {
    readConsent();
    if (!consent.marketing) forget();
    else if (apply()) persist();
  });

  window.kgAttr = {
    data: function () {
      return JSON.parse(JSON.stringify(store));
    },
    consent: function () {
      return JSON.parse(JSON.stringify(consent));
    },
    profile: profileProps
  };
})();
